import { render, staticRenderFns } from "./UpgradeDetail.vue?vue&type=template&id=7d873941&scoped=true&"
import script from "./UpgradeDetail.vue?vue&type=script&lang=js&"
export * from "./UpgradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDetail.vue?vue&type=style&index=0&id=7d873941&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d873941",
  null
  
)

export default component.exports